var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoTelefono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25489",
    "data-name": "Grupo 25489",
    transform: "translate(-1157.149 -384.416)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2214",
    "data-name": "Elipse 2214",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1157.149 384.416)",
    fill: "#e5f4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69316",
    "data-name": "Trazado 69316",
    d: "M122.1,197.389a1.766,1.766,0,0,1,0,2.493l-.518.6c-4.663,4.464-16.009-6.88-11.614-11.558l.655-.569a1.754,1.754,0,0,1,2.464.023c.017.018,1.072,1.388,1.072,1.388a1.765,1.765,0,0,1,0,2.438l-.659.829a7.274,7.274,0,0,0,3.946,3.954l.834-.663a1.764,1.764,0,0,1,2.437,0S122.078,197.371,122.1,197.389Zm-.784.828s-1.362-1.048-1.38-1.066a.626.626,0,0,0-.881,0c-.016.016-1.164.931-1.164.931a.571.571,0,0,1-.557.086,8.545,8.545,0,0,1-5.022-5.015.569.569,0,0,1,.083-.57s.915-1.149.93-1.163a.626.626,0,0,0,0-.882c-.017-.017-1.066-1.381-1.066-1.381a.626.626,0,0,0-.859.022l-.655.569c-3.212,3.863,6.621,13.151,10.006,9.952l.518-.6a.638.638,0,0,0,.048-.886Z",
    transform: "translate(1056.129 204.738)",
    fill: "#0099b7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoTelefono);
export default __webpack_public_path__ + "static/media/Icono-Telefono.9a2049116e11750d51fa4c654745db5e.svg";
export { ForwardRef as ReactComponent };